import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { v4 as uuidv4 } from "uuid";
import Images from "../../../media/images";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import inWords from './numIntoWords'
import { Link } from "react-router-dom";


const CreateJob = () => {
  const { register, handleSubmit, setValue } = useForm();
  const [searchData, setSearchData] = useState([]);
  const [cmpId, setCmpId] = useState(null);
  const [result, setResult] = useState({});
  const [selected, setSelected] = useState({ id: "", name: "" });

  const [invoiceCalc, SetInvoiceCalc] = useState([
    {
      id: uuidv4(),
      details: "",
      amount: "",
      remarks: "",
    },
    
  ]);

  const [totalAmount, setTotalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [isActive, SetIsActive] = useState(false);

  useEffect(() => {
    let finalAmount = 0;
    // let grandTotal = 0

    invoiceCalc.map((item, i) => {
      if (item.amount !== "") {
        finalAmount += parseInt(item.amount);
      }
    });

    setTotalAmount(finalAmount);

    if (discount === 0) {
      setGrandTotal(finalAmount);
      setBalance(finalAmount);
    } else {
      setGrandTotal(finalAmount - discount);
      setBalance(finalAmount - discount);

      if (isActive) {
        setBalance((finalAmount - discount) * 1.13);
      } else {
        setBalance(finalAmount - discount);
      }
    }
  }, [invoiceCalc, discount, isActive]);

  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const addItemsToArray = () => {
    const newArr = [...invoiceCalc];
    newArr.push({
      id: uuidv4(),
      details: "",
      amount: "",
      remarks: "",
    });

    SetInvoiceCalc(newArr);
  };

  const handleChangeText = (e, name, index) => {
    let newArr = [...invoiceCalc];

    newArr[index][name] = e.target.value;
    SetInvoiceCalc(newArr);
  };

  const handleSub = (data) => {
    data.discount = discount;
    data.job_order_details = invoiceCalc;
    data.company = cmpId

    // console.log(data);

    api.post('/services/joborders/', data)
      .then(response => {
        toast.success("Data registered successfully")
      }).catch(error => {
        toast.error("something went wrong")
      })
  };

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
      .get(`/services/company/${item.id}/`)
      .then((response) => {
        // console.log("Result",response.data)
        setResult(response.data);
        setCmpId(response.data.id)

      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };


  const handleOnFocus = () => {
    // console.log('Focused')
  };

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  return (
    <form className="" onSubmit={handleSubmit(handleSub)}>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create New Job Orders
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      <div className="px-3 md:!px-10 my-3 w-80 md:w-100">
        <ReactSearchAutocomplete
          items={searchData}
          onSearch={handleOnSearch}
          onHover={handleOnHover}
          onSelect={handleOnSelect}
          onFocus={handleOnFocus}
          autoFocus
          formatResult={formatResult}
          placeholder="Search Company"
        />
      </div>

      <div className="px-3 md:!px-10">
        <div className="border">
          <div className="grid md:grid-cols-2">
            {/* received date */}
            <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
              <label htmlFor="" className="text-primary-red">
                Job Orders Date:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                id="nepali-datepicker"
                placeholder="Select Nepali Date"
                {...register('orders_date', {
                  // required: false
                })}
              />
            </div>
            {/* pan no */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                PAN No.:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="PAN No."
                {...register('pan_number', {
                  // required: false
                })}
              />
            </div>
            {/* company name */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Company Name:
              </label>
              <div className="flex-grow items-center gap-2 lg:flex">

                <input
                  type="text"
                  defaultValue=""
                  id="company_name"
                  className="border-primary-blue w-full flex-grow border p-2 outline-none"
                  placeholder=" company name"
                  {...register('company_name', {
                    // required: false
                  }, setValue('company_name', result.company_name))}
                />
              </div>
            </div>
            {/* company address */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Company Address:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Company Address"
                {...register('company_address', {
                  // required: false
                }, setValue('company_address', result.company_address))}
              />
            </div>
            {/* client name */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Contact person Name:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Name"
                {...register('contact_person_name', {

                })}
              />
            </div>
            {/* contact no */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Contact No:
              </label>
              <input
                type="number"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Contact No."
                {...register('contact_person_number', {

                })}
              />
            </div>
          </div>
        </div>
        {/* user list */}
        <div className="my-5 grid place-content-center">
          <Link
            to="../direct-user-create-list/"
            className="bg-primary-green ml-10 rounded-md px-5 py-3 font-bold text-white"
          >
            Go to user list
          </Link>
        </div>
      </div>
      {/*  table */}
      <div className="w-full md:px-10">
        <div className="flex flex-col">
          <div className=" sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="wrapper overflow-atuo">
                <table className="common border-primary-blue w-full border-collapse text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Job Details
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Amount
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Remark
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">

                    {invoiceCalc.map((item, i) => {
                      return (
                        <tr className="trow border-b bg-white">
                          <td className="w-[5px] whitespace-nowrap border border-slate-700 px-6 text-sm font-light leading-[0px] text-gray-900">
                            {i + 1}
                          </td>
                          <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                            <input
                              type="text"
                              id="cash-dr"
                              name=""
                              className="w-full rounded-sm px-2 py-3"
                              defaultValue=""
                              onChange={(e) => {
                                handleChangeText(e, "details", i)
                              }}

                            />
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            <input
                              type="number"
                              id="cash-dr"
                              name=""
                              className="w-full rounded-sm px-2 py-3"
                              defaultValue=""
                              onChange={(e) => {
                                handleChangeText(e, "amount", i)
                              }}
                            />
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            <input
                              type="text"
                              id="cash-dr"
                              name=""
                              className="w-full rounded-sm px-2 py-3"
                              defaultValue=""
                              onChange={(e) => {
                                handleChangeText(e, "remarks", i)
                              }}
                            />
                          </td>
                        </tr>
                      )
                    })}

                  </tbody>
                </table>

                {/* add button */}
                <div className="list_add bg-primary-blue mt-3 inline-flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 font-bold text-white"
                  onClick={() => addItemsToArray()}
                >
                  <h1>Add</h1>
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                  </svg>
                </div>
                {/* end add button */}
                {/* calculation */}
                <div className="mt-3 md:max-w-[500px] border-primary-blue border-2 ">
                  {/* total */}
                  <div className="grid grid-cols-2 border-b  border-primary-blue">
                    <p className="text-primary-red p-3 border-r-2 border-primary-blue text-right font-semibold">
                      Total
                    </p>
                    <p className="border-primary-blue border-l-0 p-3 font-semibold">
                      {totalAmount.toFixed(2)}
                    </p>
                  </div>
                  {/* discount */}
                  <div className="border-primary-blue grid grid-cols-2 border-t-0 border-b  ">
                    <p className="text-primary-red border-primary-blue border-r-2   p-3 text-right font-semibold">
                      Discount
                    </p>
                    <input
                      type="number"
                      className="border-primary-blue  px-2"
                      placeholder="Discount"
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                  </div>
                  {/* grand total */}
                  <div className="border-primary-blue grid grid-cols-2  border-t-0 border-b  ">
                    <p className="text-primary-red border-primary-blue border-r-2  border-t-0 p-3 text-right font-semibold">
                      Grand Total
                    </p>
                    <p className="border-primary-blue  border-t-0 p-3 font-semibold">
                      {grandTotal.toFixed(2)}
                    </p>
                  </div>
                  {/* advance */}
                  <div className="border-primary-blue grid grid-cols-2  border-t-0 border-b">
                    <p className="text-primary-red border-primary-blue border-r-2  border-t-0 p-3 text-right font-semibold">
                      Advance
                    </p>
                    <input
                      type="number"
                      className="border-primary-blue  border-t-0 px-2"
                      placeholder="Advance"
                    />
                  </div>
                  {/* dew balance */}
                  <div className="border-primary-blue grid grid-cols-2  border-t-0 ">
                    <p className="text-primary-red border-primary-blue border-r-2 p-3 text-right font-semibold">
                      Dew balance
                    </p>
                    <p className="border-primary-blue  p-3 font-semibold">
                      000
                    </p>
                  </div>
                </div>

                {/* in word */}
                {/* dew balance */}
                <div className="border-primary-blue border-t-0 inline-flex items-center md:max-w-[500px] ">
                  <p className="text-primary-red p-3 text-right font-semibold">
                    In Words:
                  </p>
                  <p className="text-primary-green p-3 font-semibold capitalize">
                    {/* Three thoushand three hundren only
                     */}
                    {inWords(grandTotal)}
                  </p>
                </div>
                {/* end calculation */}
                {/* submit button */}
                <div className="flex flex-wrap items-center">
                  <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Save</a>
                  </div>
                  <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                    {/* <a href="">Submit</a> */}
                    <button type="submit">
                      Submit
                    </button>
                    
                  </div>
                  <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Approve</a>
                  </div>
                  <div className="bg-primary-red ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Print</a>
                  </div>
                </div>
                <div className="flex justify-end" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end  table */}
    </form>
  );
};
export default CreateJob;
